import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../config";

export default function PagoRedirect() {
  const { pedidoId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  // Aquí en futuro llamarás a tu pasarela real.
  // De momento dejamos botón de simulación.
  return (
    <div style={{ maxWidth: 640, margin: "40px auto", padding: 16 }}>
      <h1>Pago del pedido</h1>
      <p>Pedido: {pedidoId}</p>

      {error && <p style={{ color: "crimson" }}>{error}</p>}

      <button
        onClick={async () => {
          try {
            const res = await fetch(`${API_URL}/pedido/simular-pago/${pedidoId}`, { method: "POST" });
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || "Error");
            alert("✅ Pago simulado. Ya tienes acceso a los cursos.");
            navigate("/login");
          } catch (e) {
            setError(e.message);
          }
        }}
      >
        Simular pago (dev)
      </button>
    </div>
  );
}
